<template>
    <div style="background-color: rgba(37, 37, 38, .45);" class="w-[85%] h-full absolute z-10"></div>
    <div class="bg-[#252526] ml-[5vw] border-[1px] scale-125 border-[#47484966] w-[214px] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-50 px-[16px] py-[16px] rounded-[10px] select-none">
        <div class="">
            <div>
                <div class="flex justify-center items-center">
                    <div class="border-[#8C8C8C] bg-[#474849] text-white bg-opacity-20 border-[1px] w-full items-center flex justify-center relative rounded-[4px] px-[4px] ">
                        <div>
                            <img v-if="training.type == 'training'" src="../../assets/training_icon.svg">
                            <img v-else-if="training.type == 'gym'" src="../../assets/gym_icon.svg">
                            <img v-else-if="training.type == 'competition'" src="../../assets/competition_icon.svg">
                            <img v-else-if="training.type == 'homework'" src="../../assets/training_icon.svg">
                        </div>
                        <div 
                            class="text-center w-full relative text-[13px]"
                            :class="{
                                'left-[-10px]' : training.type
                            }"    
                        >
                            {{ training.type == 'training' ? 'Тренування' : training.type == 'gym' ? 'Зал' : training.type == 'competition' ? 'Змагання' : training.type == 'homework' ? 'Домашнє завдання' : 'Не задано' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-[11px]">
            <div>
                <div class="flex justify-center items-center">
                    <div class="border-[#8C8C8C] bg-[#474849] text-white bg-opacity-20 text-[13px] border-[1px] w-full items-center flex justify-center relative rounded-[4px] px-[4px]">{{ changeDate.split('T')[0].split('-').reverse().join('.') }}</div>
                </div>
            </div>
        </div>

        <div class="mt-[11px]">
            <div class="flex justify-center items-center">
                <div class="border-[#8C8C8C] bg-[#474849] text-white bg-opacity-20 text-[13px] border-[1px] w-full items-center flex justify-center relative rounded-[4px] px-[4px]">{{ trainingTime.start }}</div>
                <span class="font-bold mx-[13px] w-[30px] text-white">
                    <img src="../../assets/divide_arrow.svg" alt="">
                </span>
                <div class="border-[#8C8C8C] bg-[#474849] text-white bg-opacity-20 text-[13px] border-[1px] w-full items-center flex justify-center relative rounded-[4px] px-[4px]">{{ trainingTime.end }}</div>
            </div>
        </div>

        <div class="mt-[11px]">
            <div>
                <div class="flex justify-center items-center">
                    <div class="w-full">
                        <div class="border-[#8C8C8C] bg-[#474849] text-white bg-opacity-20 text-[13px] border-[1px] w-full items-center flex justify-center relative rounded-[4px] px-[4px]">{{ groupText }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-[11px]">
            <div>

                <div class="flex justify-center items-center">
                    <div class="w-full">
                        <div class="border-[#8C8C8C] bg-[#474849] text-white bg-opacity-20 text-[13px] border-[1px] w-full items-center flex justify-center relative rounded-[4px] px-[4px]">{{ locationText }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-[11px]">
            <div>

                <div class="flex justify-center items-center">
                    <div class="w-full">
                        <div class="border-[#8C8C8C] bg-[#474849] text-white bg-opacity-20 text-[13px] border-[1px] w-full flex py-[7px] pl-[7px] relative rounded-[4px] px-[4px] h-[124px] overflow-auto resize-y">
                            {{ location?.description }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-[17px]">
            <div @click="openLocationUrl(location.geo_url)">
                <div class="flex justify-center items-center">
                    <div class="w-full">
                        <div class="bg-[#0ABFC2] text-[#252526] px-3 outline-none cursor-pointer text-center placeholder-gray-500 rounded-[4px] text-[13px] py-[1.5px]">Відкрити на карті</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-[7px]" v-if="isHomework">
            <div @click="handleHomeworkButtonClick">
                <div class="flex justify-center items-center">
                    <div class="w-full">
                        <div 
                            class="border-[1px] px-3 outline-none cursor-pointer text-center placeholder-gray-500 rounded-[4px] text-[13px] py-[1.5px]"
                            :class="homeworkCompleted ? 'border-[#BD9135] text-[#BD9135] bg-transparent' : 'bg-[#BD9135] text-[#252526] border-[#BD9135]'"
                        >
                            {{ homeworkCompleted ? 'Домашнє завдання виконано!' : 'Домашнє завдання' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-[7px]">
            <div @click="$emit('close')">
                <div class="flex justify-center items-center">
                    <div class="w-full">
                        <div class="bg-[#DA4167] text-white  px-3 outline-none cursor-pointer text-center placeholder-gray-500 rounded-[4px] text-[13px] py-[1.5px]">Закрити</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <transition name="summary">
        <div v-if="summaryFlag" class="fixed inset-0 z-[60] bg-[#252526] overflow-y-auto">
            <TrainingSummaryView 
                :training="training" 
                :homework-completed="homeworkCompleted"
                @complete-homework="completeHomework"
                @close="summaryFlag = false" 
            />
        </div>
    </transition>
</template>

<script>
    import { ref, computed, onBeforeMount } from 'vue'
    import { useMainStore } from '../../store/mainStore'
    import { getLocationById, getGroupById, updateHomeworkStatus } from '../../services/apiRequests'
    import TrainingSummaryView from '../TrainingSummaryView.vue'

    export default {
        name: 'full-training-view',

        props: {
            training: {
                type: Object,
                required: true
            }
        },

        components: {
            TrainingSummaryView
        },

        setup(props, { emit }) {
            const settedDate = new Date(props.training.date)
            const settedYear = settedDate.getFullYear() > 10 ? settedDate.getFullYear() : `0${settedDate.getFullYear()}`
            const settedMonth = settedDate.getMonth() + 1 > 10 ? settedDate.getMonth() + 1 : `0${settedDate.getMonth() + 1}`
            const settedDay = settedDate.getDate() > 10 ? settedDate.getDate() : `0${settedDate.getDate()}`
            const changeDate = ref(`${settedYear}-${settedMonth}-${settedDay}`)

            const group = ref(null)
            const groupText = ref(props.training.group_label)

            const location = ref(null)
            const locationText = ref(props.training.location_label)
            const store = useMainStore()
            const summaryFlag = ref(false)
            const homeworkCompleted = ref(false)
            const isHomework = computed(() => props.training?.type === 'homework')

            const checkHomeworkCompleted = () => {
                const homeworkList = props.training?.homework || []
                homeworkList.forEach(homework => {
                    if (homework.status === 'completed' && homework.student_id === store.student.student_id) {
                        homeworkCompleted.value = true
                    }
                })
            }
            
            onBeforeMount(async () => {

                const currentGroupRes = await getGroupById(props.training.group_id)
                group.value = currentGroupRes.data

                const currentLocationRes = await getLocationById(props.training.location_id)
                location.value = currentLocationRes.data

                checkHomeworkCompleted()
            })

            const trainingTime = ref({
                start: props.training.start_time,
                end: props.training.end_time
            })

            const openLocationUrl = (url) => {
                window.open(url, '_blank')
            }

            const openSummary = () => {
                summaryFlag.value = true
            }

            const handleHomeworkButtonClick = () => {
                if (homeworkCompleted.value) {
                    return
                }
                openSummary()
            }

            const completeHomework = async () => {
                if (homeworkCompleted.value) return
                try {
                    await updateHomeworkStatus(
                        store.student.student_id,
                        `${store.student.name} ${store.student.surname}`,
                        props.training.training_id,
                        'completed'
                    )
                    homeworkCompleted.value = true
                } catch (e) {
                    console.error('Failed to update homework status', e)
                }
            }
      

            return {
                settedDate,
                settedYear,
                settedMonth,
                settedDay,
                changeDate,
                group,
                groupText,
                trainingTime,
                locationText,
                location,
                openLocationUrl,
                openSummary,
                handleHomeworkButtonClick,
                summaryFlag,
                homeworkCompleted,
                isHomework,
                completeHomework
            }
        }
    }
</script>

<style scoped>
    .summary-enter-active, 
    .summary-leave-active {
        transition: opacity 0.2s ease-in-out;
    }

    .summary-enter-from, 
    .summary-leave-to {
        opacity: 0;
    }
</style>
